

// Calcul des participations d'une commande dans le panier
function calculateParticipation(price) {
  console.log("Calculating participation with price:", price);
  
  if (!price) {
    console.log("Price is undefined or zero. Returning 0 participation.");
    return 0;
  }

  const priceInCents = parseInt(price * 100, 10); // Convertir en centimes
  console.log("Price in cents:", priceInCents);

  const participationNumber = Math.round(priceInCents / 99); // Diviser par 99 et arrondir
  console.log("Calculated participation number:", participationNumber);

  return participationNumber;
}